import type { Ref } from "react";
import colors from "@styles/colors.module.scss";
import type { Entity } from "@common/types/entity";
import { getEntityAvatarName } from "@helpers/entityAvatarName";
import { Avatar, type AvatarSize } from "./Avatar";

export type EntityAvatarImageEntity = Pick<
    Entity,
    "name" | "iconColor" | "logo"
> & {
    isPersonal?: boolean;
};

export interface EntityAvatarImageProps {
    entity: EntityAvatarImageEntity;
    size?: AvatarSize;
    className?: string;
    /** Set when the entity's name is visible next to the avatar. */
    "aria-hidden"?: boolean;
    ref?: Ref<HTMLSpanElement>;
}

/**
 * An entity's logo as a square, else the initial of its name on its
 * `iconColor`. Personal entities are always gray. `EntityAvatar` adds
 * copy-id on right-click around it.
 */
export const EntityAvatarImage = ({
    entity,
    size,
    className,
    "aria-hidden": isAriaHidden,
    ref,
}: Readonly<EntityAvatarImageProps>) => (
    <Avatar
        ref={ref}
        name={getEntityAvatarName(entity)}
        src={entity.logo}
        color={entity.isPersonal ? colors.gray300 : entity.iconColor}
        shape="square"
        size={size}
        className={className}
        aria-hidden={isAriaHidden}
    />
);
